import { render, staticRenderFns } from "./AnosafraJobsForm.vue?vue&type=template&id=172c73b1"
import script from "./AnosafraJobsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AnosafraJobsForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports